<div align="center">
    <h1 mat-dialog-title> <b>{{'IRIDIUM.FETCH_DATA' | translate}}</b> </h1>
</div>
<hr>
<div mat-dialog-content align="center">
    <div>
        <h3>{{'IRIDIUM.SELECT_STATION' | translate}}</h3>
        <br />
        <mat-select placeholder="{{'IRIDIUM.SELECT_STATION' | translate}}" (selectionChange)="[setDispUuidAndFilterDataTypes($event)]" >
            <mat-option *ngFor="let disp of iridiumDisp" [value]="disp.uuid">
                {{disp.nombre}}
            </mat-option>
        </mat-select>
    </div>  
    <br />
    <hr>
    <div>
        <h3>{{'IRIDIUM.SELECT_DATATYPE' | translate}} </h3>
        <br />
        <mat-select placeholder="{{'IRIDIUM.SELECT_DATATYPE' | translate}}" (selectionChange)="[setDTuuid($event)]" >
            <mat-option *ngFor="let dt of selectableDataTypes" [value]="dt.uuid">
                {{'DATA_TYPES_AND_AGRUPATIONS.'.concat(dt.nombre) | translate }}
            </mat-option>
        </mat-select>
        <br />
        <br />
    </div>
</div>
<hr>
<br />
<div align="right">
  <button mat-button style="background-color:red; color:white" (click)="onNoClick()">{{'CONFIRM_MODAL.NO' | translate }}</button>
  <button mat-button style="background-color:blue; color:white; margin-left: 10px" mat-dialog-close  cdkFocusInitial (click)="requestData()">{{'CONFIRM_MODAL.ACCEPT' | translate }}</button>
</div>


